import { AxiosResponse } from 'axios';
import { privateFetcher } from 'services';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';

interface ShippingAttachmentApiResponse {
  data: Record<string, unknown>;
}

export const getShippingAttachmentFetcher = async (
  orgId: number,
  shipmentPk: number,
): Promise<AxiosResponse<ShippingAttachmentApiResponse>> => {
  const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/shipments/${orgId}/documents/labels`;

  try {
    const data = await privateFetcher.get(url, {
      params: { shipment_pk: shipmentPk },
    });
    return data;
  } catch (error) {
    throw new APIError(error.message);
  }
};
